"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        this.score = 0;
        this.scoreVal = document.querySelector(".game-score");
        this.field = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.arr = this.field.map((row)=>[
                ...row
            ]);
    }
    shiftLeft() {
        let empty = -1;
        for(let i = 0; i < 4; i++){
            empty = -1;
            for(let j = 0; j < 4; j++){
                if (this.field[i][j] === 0 && empty === -1) empty = j;
                else if (this.field[i][j] !== 0 && empty !== -1) {
                    this.field[i][empty] = this.field[i][j];
                    this.field[i][j] = 0;
                    empty++;
                }
            }
        }
    }
    moveLeft() {
        this.shiftLeft();
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 3; j++)if (this.field[i][j] !== 0 && this.field[i][j] === this.field[i][j + 1]) {
                const newVal = this.field[i][j] * 2;
                this.field[i][j] = newVal;
                this.field[i][j + 1] = 0;
                this.score += newVal;
                this.getScore();
            }
        }
        this.shiftLeft();
    }
    shiftRight() {
        let empty = -1;
        for(let i = 0; i < 4; i++){
            empty = -1;
            for(let j = 3; j >= 0; j--){
                if (this.field[i][j] === 0 && empty === -1) empty = j;
                else if (this.field[i][j] !== 0 && empty !== -1) {
                    this.field[i][empty] = this.field[i][j];
                    this.field[i][j] = 0;
                    empty--;
                }
            }
        }
    }
    moveRight() {
        this.shiftRight();
        for(let i = 0; i < 4; i++){
            for(let j = 3; j >= 0; j--)if (this.field[i][j] !== 0 && this.field[i][j] === this.field[i][j - 1]) {
                const newVal = this.field[i][j] * 2;
                this.field[i][j] = newVal;
                this.field[i][j - 1] = 0;
                this.score += newVal;
                this.getScore();
            }
        }
        this.shiftRight();
    }
    shiftUp() {
        for(let j = 0; j < 4; j++){
            let empty = -1;
            for(let i = 0; i < 4; i++){
                if (this.field[i][j] === 0 && empty === -1) empty = i;
                else if (this.field[i][j] !== 0 && empty !== -1) {
                    if (i !== empty) {
                        this.field[empty][j] = this.field[i][j];
                        this.field[i][j] = 0;
                        empty++;
                    }
                }
            }
        }
    }
    moveUp() {
        this.shiftUp();
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 3; j++)if (this.field[j][i] !== 0 && this.field[j][i] === this.field[j + 1][i]) {
                const newVal = this.field[j][i] * 2;
                this.field[j][i] = newVal;
                this.field[j + 1][i] = 0;
                this.score += newVal;
            }
        }
        this.shiftUp();
    }
    shiftDown() {
        let empty = -1;
        for(let i = 0; i < 4; i++){
            empty = -1;
            for(let j = 3; j >= 0; j--){
                if (this.field[j][i] === 0 && empty === -1) empty = j;
                else if (this.field[j][i] !== 0 && empty !== -1) {
                    this.field[empty][i] = this.field[j][i];
                    this.field[j][i] = 0;
                    empty--;
                }
            }
        }
    }
    moveDown() {
        this.shiftDown();
        for(let i = 0; i < 4; i++){
            for(let j = 3; j > 0; j--)if (this.field[j][i] !== 0 && this.field[j][i] === this.field[j - 1][i]) {
                const newVal = this.field[j][i] * 2;
                this.field[j][i] = newVal;
                this.field[j - 1][i] = 0;
                this.score += newVal;
                this.getScore();
            }
        }
        this.shiftDown();
    }
    /**
   * @returns {number}
   */ getScore() {
        this.scoreVal.textContent = this.score;
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.field;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        let emptyField = true;
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.field[i][j] !== 0) emptyField = false;
        }
        if (emptyField) return "idle";
        if (this.winerGame()) return "win";
        if (!this.canMove()) return "lose";
        return "playing";
    }
    /**
   * Starts the game.
   */ start() {
        this.generateCell();
    }
    /**
   * Resets the game.
   */ restart() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++)this.field[i][j] = 0;
        this.generateCell();
        this.generateCell();
        this.score = 0;
        this.getScore();
    }
    // Add your own methods here
    generateCell() {
        const emptyCells = [];
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.field[i][j] === 0) emptyCells.push({
                x: i,
                y: j
            });
        }
        if (emptyCells.length > 0) {
            const { x: x, y: y } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            if (this.field[x][y] === 0) this.field[x][y] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    canMove() {
        let game = false;
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 3; j++){
                if (this.field[j][i] === 0) game = true;
                if (this.field[j][i] !== 0) {
                    if (this.field[j][i] === this.field[j + 1][i] || this.field[i][j] === this.field[i][j + 1]) game = true;
                }
            }
            for(let j = 3; j > 0; j--){
                if (this.field[j][i] === 0) game = true;
                if (this.field[j][i] !== 0) {
                    if (this.field[j][i] === this.field[j - 1][i] || this.field[i][j] === this.field[i][j - 1]) game = true;
                }
            }
        }
        return game;
    }
    winerGame() {
        let win = false;
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.field[i][j] === 2048) win = true;
        }
        return win;
    }
    isMoveMade(previousField) {
        const moved = previousField !== JSON.stringify(this.field);
        return moved;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$table = document.querySelector(".game-field");
const $09e991522ca7e64e$var$startButton = document.querySelector(".start");
function $09e991522ca7e64e$var$keyMove(ev) {
    const previousField = JSON.stringify($09e991522ca7e64e$var$game.getState());
    switch(ev.key){
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        default:
            return;
    }
    if ($09e991522ca7e64e$var$game.isMoveMade(previousField)) $09e991522ca7e64e$var$game.generateCell();
    $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$vizualized();
    $09e991522ca7e64e$var$game.scoreVal.textContent = $09e991522ca7e64e$var$game.score;
}
function $09e991522ca7e64e$var$vizStart() {
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$startButton.textContent = "Restart";
    $09e991522ca7e64e$var$startButton.style.fontSize = "17px";
    $09e991522ca7e64e$var$startButton.addEventListener("mouseenter", ()=>{
        $09e991522ca7e64e$var$startButton.style.backgroundColor = "#f87474";
    });
    $09e991522ca7e64e$var$startButton.addEventListener("mouseleave", ()=>{
        $09e991522ca7e64e$var$startButton.style.backgroundColor = "#f1b2b2";
    });
    $09e991522ca7e64e$var$messageStart.style.display = "none";
}
function $09e991522ca7e64e$var$vizRestart() {
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$messageWin.style.display = "none";
    $09e991522ca7e64e$var$messageLose.style.display = "none";
    $09e991522ca7e64e$var$vizualized();
}
function $09e991522ca7e64e$var$vizualized() {
    for(let i = 0; i < 4; i++){
        for(let j = 0; j < 4; j++)if ($09e991522ca7e64e$var$game.field[i][j] === 0) $09e991522ca7e64e$var$table.rows[i].cells[j].textContent = "";
        else $09e991522ca7e64e$var$table.rows[i].cells[j].textContent = $09e991522ca7e64e$var$game.field[i][j];
    }
    $09e991522ca7e64e$var$colorCells();
    if (!$09e991522ca7e64e$var$game.canMove()) $09e991522ca7e64e$var$messageLose.style.display = "block";
    if ($09e991522ca7e64e$var$game.winerGame()) $09e991522ca7e64e$var$messageWin.style.display = "block";
}
function $09e991522ca7e64e$var$colorCells() {
    const cells = document.querySelectorAll(".field-cell");
    cells.forEach((cell)=>{
        const value = parseInt(cell.textContent, 10);
        cell.className = "field-cell";
        if (value > 0) cell.classList.add(`field-cell--${value}`);
    });
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$startButton.textContent === "Start") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$vizStart();
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
    } else if ($09e991522ca7e64e$var$startButton.textContent === "Restart") {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$vizRestart();
    }
    document.addEventListener("keydown", $09e991522ca7e64e$var$keyMove);
    $09e991522ca7e64e$var$vizualized();
});


//# sourceMappingURL=index.22281a40.js.map
